import { useToast } from '../../../../hooks/useToast';
import { Tooltip } from '../../../common/Tooltip';
import styles from '../ScenarioGenerator.module.css';

/**
 * シーン詳細の各欄 (セリフ / テロップ / ナレーション) の全文をクリップボードへコピーする鉛筆並びのボタン。
 * 欄同士の入れ替え・流用 (セリフ→テロップ等) を 1 クリックで始められるようにする (2026-10-22 要望)。
 * 本文が空のときは出さない。見た目は fieldEditButton (鉛筆) と揃える。
 */
export function CopyTextButton({ text, label }: { text: string; label: string }) {
  const toast = useToast();
  if (!text.trim()) return null;
  const title = `${label}をコピー`;
  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.show(`${label}をコピーしました`);
    } catch {
      toast.error('コピーに失敗しました');
    }
  };
  return (
    <Tooltip content={title}>
      <button
        type="button"
        className={styles.fieldEditButton}
        onClick={() => void handleClick()}
        aria-label={title}
        data-testid="copy-text-button"
      >
        <img src="/duplicate.svg" alt="" className={styles.fieldEditIcon} />
      </button>
    </Tooltip>
  );
}
